import React, { createContext, useContext } from "react";

/**
 * Host-supplied config for the read-only page-document renderers that need an
 * environment value the block data doesn't carry. Currently just the Mapbox
 * token used by `PageLocationView` for its static map image. Absent by default
 * (renderers fall back gracefully).
 */
export interface PageRenderConfig {
  /** Mapbox access token for static-map images (PageLocationView). */
  mapboxToken?: string | null;
}

const PageRenderConfigContext = createContext<PageRenderConfig>({});

export const PageRenderConfigProvider: React.FC<{
  value: PageRenderConfig;
  children: React.ReactNode;
}> = ({ value, children }) => (
  <PageRenderConfigContext.Provider value={value}>
    {children}
  </PageRenderConfigContext.Provider>
);

export function usePageRenderConfig(): PageRenderConfig {
  return useContext(PageRenderConfigContext);
}
